import React, { useEffect, useState } from "react";
import Style from "./index.module.css";



const ModalBox = ({header,message,onOk,open,onClose,onCancel})=>{

    const [active,setActive] = useState(open);

    useEffect(()=>{
        setActive(open);
    },[open])


    const okHandler = (e)=>{
        e.stopPropagation();

        onOk && onOk();
    }
    const cancelHandler = (e)=>{
        e.stopPropagation();

        onCancel && onCancel();
    }

    const closeHandler = (e)=>{
        if(onClose){
            setActive(false);
            onClose();
        }
    }

    return(
        <>
        {
            active &&
            <div className={Style.modalBox} onClick={closeHandler}>
            <div className={Style.modalInner} onClick={(e)=> e.stopPropagation() }>
                <div 
                className={Style.modalHeader}
                >
                    <p>{header}</p>
            
                </div>
                <div className={Style.modalContent}>
                    {message}
                </div>
                <div className={Style.modalBtnCnt}>
                    {
                        onCancel &&
                        <button 
                        className={Style.modalBtn} 
                        onClick={cancelHandler}>
                            Cancel
                        </button>
                    }
                    {
                        onOk &&
                        <button 
                        className={Style.modalBtn} 
                        onClick={okHandler}>
                            OK
                        </button>
                    }
                </div>

            </div>
        </div>
        }
        </>
    )
}

export default ModalBox;